// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__BfQ47","range":"MonthRangeSwitch_range__2yAP9","disabled":"MonthRangeSwitch_disabled__2_wJP"};